import script from "./TaskCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaskCard.vue?vue&type=script&lang=ts&setup=true"

import "./TaskCard.vue?vue&type=style&index=0&id=479ccd0e&lang=less"

const __exports__ = script;

export default __exports__